import * as React from "react";
import {Pagination} from 'react-admin';

export const CustomPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 75, 100]} {...props}/>